import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=07d4947b&scoped=true&"
import script from "./VehicleInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d4947b",
  null
  
)

component.options.__file = "VehicleInfo.vue"
export default component.exports